import {
  Button,
  SIZE,
  VARIANT,
} from "@metacrm/metacrm-material-ui/dist/Button";
import { Box } from "@mui/material";
import { Grid } from "@mui/material";
import { StyledWhiteContainer } from "features/metadesk/settings/common.styles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import _, { isEqual } from "lodash";
import { useOutletContext } from "react-router";
import { useFetchOptInConfig } from "features/metadesk/redux/hooks";
import { useTheme } from "@mui/styles";
import CustomizeOptIn from "../components/CustomizeOptIn";
import SaveDiscardActions from "features/metadesk/settings/integrations/components/SaveDiscardActions";

export default function Customization({
  data,
  handleRefetch,
  setHasChanges,
  hasSaved,
  setHasSaved,
}) {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();
  const { updateOptInConfig } = useFetchOptInConfig();
  const theme = useTheme();

  const firstFetchData = useRef(data);
  const [configs, setConfigs] = useState(data);

  const dispatchSnackbar = useDispatchSnackbar();
  const saveConfig = async () => {
    try {
      await updateOptInConfig({
        entityName,
        config: {
          ...configs,
          websiteOptInId: _.get(data, "_id"),
        },
      });
      await handleRefetch();
      firstFetchData.current = data;
      dispatchSnackbar({
        message: formatMessage({
          id: "websiteOptIn.configure.saveSuccess",
        }),
        variant: "success",
      });
    } catch (err) {
      console.log(err);
      dispatchSnackbar({ err });
    }
  };

  const handleDiscard = () => {
    setConfigs(firstFetchData.current); // 回到初始狀態
  };

  const isSaveDisabled = useMemo(() => {
    return isEqual(configs, firstFetchData.current);
  }, [configs]);

  useEffect(() => {
    setHasChanges(!isSaveDisabled);
  }, [configs]);

  const defaultColor = [
    {
      name: "backgroundColor",
      title: "Color",
      color: configs.backgroundColor || "#ffffff",
    },
  ];
  const [colorArray, setColorArray] = useState(defaultColor);
  const handleColorChange = (event) => {
    const { name, value } = event.target;
    const newColorArray = colorArray.map((item) => {
      if (item.name === name) {
        return { ...item, color: value };
      }
      return item;
    });

    setColorArray(newColorArray);
    handleChange({ event });
  };
  const handleChange = ({ event }) => {
    const { name, value } = event.target;
    setConfigs({ ...configs, [name]: value });
  };

  return (
    <div className="fade-up-more">
      <StyledWhiteContainer sx={{ margin: "12px 0", padding: "40px" }}>
        <Grid container spacing={1}>
          <CustomizeOptIn
            handleChange={handleChange}
            configs={configs}
            colorArray={colorArray}
            handleColorChange={handleColorChange}
          />
        </Grid>
      </StyledWhiteContainer>
      <SaveDiscardActions
        onDiscard={handleDiscard}
        onSave={saveConfig}
        isDisabled={isSaveDisabled}
        hasSaved={hasSaved}
        setHasSaved={setHasSaved}
      />
    </div>
  );
}
